module.exports = __webpack_public_path__ + "img/4c508530b122de81a85538dceffecf79.png";